import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../Layouts/Sidebar";
import SessionGate from "./SessionGate";
import { loadSession } from "../../redux/auth/actions";
import {
  selectIsAuthenticated,
  selectProfile,
  selectSessionStatus,
} from "../../redux/auth/selectors";

/*
 * Every signed-in page goes through here.
 *
 * On boot the dashboard asks the server who is signed in and what they may
 * see, and keeps the browser copy only as a cache: with one, the page opens
 * at once and the answer replaces it; without one, the page waits for the
 * answer rather than drawing an empty menu. That empty menu was the
 * blank-sidebar bug: a token left behind with nothing else saved.
 */
export default function PrivateRoutes({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const profile = useSelector(selectProfile);
  const sessionStatus = useSelector(selectSessionStatus);

  useEffect(() => {
    if (isAuthenticated && sessionStatus === "idle") {
      dispatch(loadSession());
    }
  }, [isAuthenticated, sessionStatus, dispatch]);

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (!profile) {
    return (
      <SessionGate
        status={sessionStatus}
        onRetry={() => dispatch(loadSession())}
      />
    );
  }

  return (
    <div className="header-sidebar">
      <div className="sidebar">
        <Sidebar />
      </div>
      <div className="right-side">
        <div className="children">{children}</div>
      </div>
    </div>
  );
}
